<template>
  <b-card>
    <b-row>
      <b-col lg="6" class="mb-4">
        <h4>Cargar archivo</h4>
        <b-form-file @change="upload" v-model="file"/>
        <span class="text-muted">Cargue los archivos para su verificacion.</span>
      </b-col>
      <b-col lg="6" class="mb-4">
        <h4>Listado de archivos</h4>
        <b-list-group>
          <b-list-group-item v-for="file of list" :key="file._id" class="d-flex justify-content-between">
            <a :href="file.url" target="_blank">{{ file.name }}</a>
            <span>
              <b-button @click="approve(file)">{{ file.confirmed ? 'SI' : 'NO' }}</b-button>
              <b-button @click="deleteFile(file)" title="Borrar archivo">
                <i class="ni ni-fat-remove"></i>
              </b-button>
            </span>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {get, post} from "@/util/axiosRequest";

export default {
  name: "Files",
  data: () => ({
    user_id: null,
    file: null,
    list: []
  }),
  methods: {
    upload(e) {
      const file = e.target.files[0];
      const form = new FormData()
      form.append('file', file);
      post(`users/add-file/${this.user_id}`, form, true).then(({data}) => {
        this.list.push(data)
        this.file = null;
      })
    },
    load() {
      get(`users/list-files/${this.user_id}`).then(({data}) => {
        this.list = data;
      })
    },
    approve(file) {
      post(`users/approve-file`, {_id: file._id}, true)
        .then(() => {
          this.load();
        })
    },
    deleteFile(file) {
      this.$swal({
        title: 'Esta seguro?',
        icon: 'question',
        showCancelButton: true,
        showConfirmButtom: true,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
        confirmButtonText: 'Si'
      }).then(({isConfirmed}) => {
        if (isConfirmed){
          post(`users/delete-file`, {_id: file._id}, true)
            .then(() => {
              this.load();

            })
        }
      })
    }
  },
  mounted() {
    this.user_id = this.$route.params.id;
    this.load()
  }
}
</script>

<style scoped>

</style>
